import './bootstrap.js';
import {createApp, defineAsyncComponent, h} from 'vue';
import {createPinia} from 'pinia';

import App from "./Layouts/App.vue";
import router from "./router";
import mitt from "mitt";
import Maska from 'maska'
import LocalizeMixin from "./Mixins/LocalizeMixin";
import {useLanguagesStore} from "./Stores/LanguagesStore";
import {ClickOutside} from "./Utils/ClickOutside";
import {vLazyBackground} from "./Directives/LazyBackground";
import {initConsent} from "./Utils/Consent";
import {guardExternalIframes} from "./Utils/EmbedGuard";



const app = createApp({
	render: () => h(App),
	setup() {
		return {
			languagesStore: useLanguagesStore(),
		}
	},
	data() {
		return {}
	}
});

app.use(createPinia());
app.use(router);
app.use(Maska)
app.mixin(LocalizeMixin);

export const emitter = mitt();
// @ts-ignore
const env = import.meta.env;

app.provide('emitter', emitter);
app.component('v-select', defineAsyncComponent(() => import("vue-select")));
app.directive('click-outside', ClickOutside);
app.directive('lazy-bg', vLazyBackground);

// The cookie choice: the banner library comes after the load, in its own chunk; the iframes of other sites in the texts
// are blocked from the start until the visitor allows the external content
guardExternalIframes();
window.addEventListener('load', () => {
	if ('requestIdleCallback' in window) {
		window.requestIdleCallback(() => void initConsent(), {timeout: 2000});
	} else {
		setTimeout(() => void initConsent(), 1000);
	}
}, {once: true});

if (env.VITE_MIX !== 'staging' && env.VITE_MIX !== 'local') {
	const startSentry = () => import("./Utils/SentryInit").then(({initSentry}) => initSentry(app, router, env));
	window.addEventListener('load', () => {
		if ('requestIdleCallback' in window) {
			window.requestIdleCallback(startSentry, {timeout: 5000});
		} else {
			setTimeout(startSentry, 3000);
		}
	}, {once: true});
}

const stylesheetsLoaded = (): Promise<unknown> => Promise.all(
	Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')).map((link) => link.sheet
		? Promise.resolve()
		: new Promise<void>((resolve) => {
			link.addEventListener('load', () => resolve(), {once: true});
			link.addEventListener('error', () => resolve(), {once: true});
		}))
);

stylesheetsLoaded().then(() => document.getElementById('app')?.setAttribute('data-ready', ''));

app.mount("#app");
